import { useContext } from 'react';
import { Box, Select, MenuItem, FormControl, InputLabel, Typography, Divider, FormControlLabel, Switch, useTheme as useMuiTheme, Paper } from '@mui/material';
// import { SettingsContext } from './SettingsContext.jsx';
import { UserContext } from '../Auth.jsx';
import { endpoints } from '../Chat/Endpoints.jsx'; // Import endpoints
import { useLLMSettings } from '../../contexts/LLMSettingsContext.jsx'; // Import LLM context
import { ThemeSwitchToggle } from '../ThemeToggle.jsx'; // Import new theme toggle component

import CacheManagement from '../Settings/CacheManagement.jsx'; // Import cache management component
import ChatSettings from '../Settings/ChatSettings.jsx'; // Import chat settings component
import ChatHistoryManagement from '../Settings/ChatHistoryManagement.jsx'; // Import chat history management component


export default function Settings() {
  // Access shared "apiEndpoint" and "context" from our SettingsContext
  const { user } = useContext(UserContext);
  
  // Use global LLM settings instead of local state
  const { selectedLLM, updateLLM } = useLLMSettings();
  
  // Use MUI theme for styling
  const theme = useMuiTheme();

  console.log('settings:', user?.settings);

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      padding: 2 
    }}>
      
      <Typography variant="h4" sx={{ marginBottom: 2, fontWeight: 'bold' }}>
        Settings
      </Typography>
      
      {/* General Settings Section */}
      <Paper elevation={2} sx={{ padding: 3, marginBottom: 3 }}>
        <Typography variant="h6" sx={{ marginBottom: 3, fontWeight: 'medium' }}>
          General Settings
        </Typography>
        
        {/* Theme Toggle */}
        <Box sx={{ marginBottom: 2 }}>
          <ThemeSwitchToggle label="Dark Mode" />
        </Box>
        
        {/* LLM Selector - Admin Only */}
        {user?.admin && (
          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <InputLabel id="llm-selector-label"
                sx={{ 
                  backgroundColor: theme.palette.background.paper,
                  paddingX: 0.5,
                  color: theme.palette.text.secondary
                }}>
                Select LLM Model
            </InputLabel>
            <Select
              labelId="llm-selector-label"
              value={selectedLLM || '/api/toolchat/gpt-4.1'} // Fallback to default if selectedLLM is null/undefined
              onChange={(e) => updateLLM(e.target.value)}
              displayEmpty
            >
              {endpoints && endpoints.length > 0 ? (
                endpoints.map((endpoint) => (
                  <MenuItem key={endpoint.value} value={endpoint.value}>
                    {endpoint.label}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="/api/toolchat/gpt-4.1">
                  GPT-4.1 (Default)
                </MenuItem>
              )}
            </Select>
          </FormControl>
        )}
        

      </Paper>
      
      {/* Chat Settings Section */}
      <ChatSettings />
      
      {/* Chat History Management Section */}
      <ChatHistoryManagement />
      
      {/* Cache Management Section */}
      <CacheManagement />
      
    </Box>
  );
}
